export const searchNestedProperties = (
  queryStringArray: (string | number)[] = [],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  searchObject: { [key: string]: any } = {},
) => {
  return queryStringArray.reduce((parent, child) => {
    if (parent && parent[child]) {
      return parent[child];
    }
    return null;
  }, searchObject);
};
